import React from 'react';
import './LoadingAnimation.css';

export default () => (
  <div className="LoadingAnimation">
    <div className="LoadingAnimation-circle" />
    <div className="LoadingAnimation-circle" />
  </div>
);
